// Texts of the Branch Users section (Arabic first, English). Keys are the same in both languages.

export const BRANCH_USERS_TEXT = {
  ar: {
    title: "مستخدم الفرع",
    hint: "مستخدم الفرع يدخل إلى LUD ويرى الفروع المعيّنة له فقط. يمكن تعيين المستخدم نفسه لعدة فروع.",
    none: "لا يوجد مستخدمون معيّنون لهذا الفرع.",
    loading: "جاري تحميل المستخدمين...",
    loadError: "تعذر تحميل مستخدمي الفرع.",
    retry: "إعادة المحاولة",
    selectExisting: "اختيار مستخدم موجود",
    createNew: "إنشاء مستخدم جديد",
    close: "إغلاق",
    search: "ابحث بالاسم أو البريد",
    searchHint: "تظهر هنا حسابات مستخدمي الفروع المرتبطة بمتاجرك فقط.",
    noResults: "لا توجد حسابات مطابقة.",
    assign: "تعيين",
    assigned: "معيّن",
    remove: "إزالة التعيين",
    edit: "تعديل",
    save: "حفظ",
    saving: "جاري الحفظ...",
    cancel: "إلغاء",
    resend: "إعادة إرسال الدعوة",
    name: "الاسم",
    phone: "الجوال (اختياري)",
    username: "اسم المستخدم لدخول LUD",
    usernamePlaceholder: "jeddah.cashier",
    usernameHint: "هذا هو البريد الذي يُستخدم لتسجيل الدخول إلى LUD. النطاق ثابت ولا يمكن تغييره.",
    loginPreview: "بريد الدخول",
    contactEmail: "البريد الإلكتروني للتواصل",
    contactHint: "بريد حقيقي يُستخدم للدعوة والتواصل وتعيين كلمة المرور (مثال: cashier@example.com).",
    loginEmail: "بريد الدخول",
    contact: "بريد التواصل",
    invitationPending: "بانتظار تعيين كلمة المرور",
    disabled: "معطّل",
    shared: "حساب مشترك مع متجر آخر",
    otherBranches: "الفروع المعيّنة",
    removeTitle: "إزالة تعيين المستخدم",
    removeMessage: (user, branch) => `سيتم إزالة «${user}» من فرع «${branch}» فقط. يبقى الحساب وتعييناته الأخرى كما هي.`,
    created: "تم إنشاء المستخدم وتعيينه للفرع.",
    createdInvited: "تم إنشاء المستخدم وإرسال دعوة تعيين كلمة المرور إلى بريد التواصل.",
    createdNotInvited: "تم إنشاء المستخدم وتعيينه، لكن تعذر إرسال الدعوة. يمكنك إعادة إرسالها.",
    reused: "هذا الحساب موجود وتم تعيينه للفرع.",
    assignedOk: "تم تعيين المستخدم للفرع.",
    removedOk: "تمت إزالة التعيين.",
    updatedOk: "تم تحديث بيانات المستخدم.",
    invitationSent: "تم إرسال الدعوة.",
    invitationFailed: "تعذر إرسال الدعوة. حاول لاحقًا.",
    sharedEditHint: "هذا الحساب مرتبط بمتجر آخر؛ تُعدَّل بياناته من خلال دعم LUD.",
    required: "هذا الحقل مطلوب",
    badUsername: "اسم المستخدم من 3 إلى 40 حرفًا: حروف إنجليزية وأرقام ونقطة وشرطة فقط.",
    badEmail: "أدخل بريدًا إلكترونيًا صحيحًا (ليس بنطاق lud.net).",
    badPhone: "رقم جوال غير صالح",
    errors: {
      LOGIN_EMAIL_TAKEN: "بريد الدخول هذا مستخدم بالفعل. اختر اسم مستخدم آخر.",
      CONTACT_EMAIL_TAKEN: "بريد التواصل هذا مرتبط بحساب آخر.",
      INVALID_USERNAME: "اسم المستخدم غير صالح.",
      USERNAME_RESERVED: "اسم المستخدم هذا محجوز.",
      INVALID_CONTACT_EMAIL: "بريد التواصل غير صالح.",
      USER_DISABLED: "هذا الحساب معطّل ولا يمكن تعيينه.",
      USER_NOT_FOUND: "المستخدم غير موجود أو غير متاح لك.",
      SHARED_ACCOUNT: "هذا الحساب مرتبط بمتجر آخر؛ تُعدَّل بياناته من خلال دعم LUD.",
      SETUP_RESEND_COOLDOWN: "تم إرسال دعوة قبل لحظات. انتظر دقيقة ثم أعد المحاولة.",
      ALREADY_SET_UP: "هذا المستخدم عيّن كلمة المرور بالفعل.",
      CONCURRENT_CHANGE: "تم تغيير الحساب في نفس الوقت. أعد المحاولة.",
      NETWORK: "تعذر الاتصال بالخادم.",
    },
    errorFallback: "تعذر تنفيذ العملية.",
  },
  en: {
    title: "Branch User",
    hint: "A branch user signs in to LUD and sees only the branches assigned to them. The same user can be assigned to several branches.",
    none: "No user is assigned to this branch.",
    loading: "Loading users...",
    loadError: "Could not load the branch users.",
    retry: "Try again",
    selectExisting: "Select Existing User",
    createNew: "Create New User",
    close: "Close",
    search: "Search by name or email",
    searchHint: "Only branch user accounts connected to your stores are shown.",
    noResults: "No matching accounts.",
    assign: "Assign",
    assigned: "Assigned",
    remove: "Remove Assignment",
    edit: "Edit",
    save: "Save",
    saving: "Saving...",
    cancel: "Cancel",
    resend: "Resend invitation",
    name: "Name",
    phone: "Phone (optional)",
    username: "LUD sign-in username",
    usernamePlaceholder: "jeddah.cashier",
    usernameHint: "This is the email used to sign in to LUD. The domain is fixed and cannot be changed.",
    loginPreview: "Sign-in email",
    contactEmail: "Contact email",
    contactHint: "A real email used for the invitation, account communication and password setup (e.g. cashier@example.com).",
    loginEmail: "Sign-in email",
    contact: "Contact email",
    invitationPending: "Waiting for password setup",
    disabled: "Disabled",
    shared: "Account shared with another store",
    otherBranches: "Assigned branches",
    removeTitle: "Remove user assignment",
    removeMessage: (user, branch) => `"${user}" will be removed from the branch "${branch}" only. The account and its other assignments stay as they are.`,
    created: "The user was created and assigned to the branch.",
    createdInvited: "The user was created and an invitation to set the password was sent to the contact email.",
    createdNotInvited: "The user was created and assigned, but the invitation could not be sent. You can resend it.",
    reused: "This account already existed and was assigned to the branch.",
    assignedOk: "The user was assigned to the branch.",
    removedOk: "The assignment was removed.",
    updatedOk: "The user was updated.",
    invitationSent: "The invitation was sent.",
    invitationFailed: "The invitation could not be sent. Try again later.",
    sharedEditHint: "This account is also used by another store; LUD support changes its details.",
    required: "This field is required",
    badUsername: "3-40 characters: English letters, digits, dot, dash or underscore.",
    badEmail: "Enter a valid email (not a lud.net address).",
    badPhone: "Invalid phone number",
    errors: {
      LOGIN_EMAIL_TAKEN: "This sign-in email is already in use. Choose another username.",
      CONTACT_EMAIL_TAKEN: "This contact email belongs to another account.",
      INVALID_USERNAME: "The username is not valid.",
      USERNAME_RESERVED: "This username is reserved.",
      INVALID_CONTACT_EMAIL: "The contact email is not valid.",
      USER_DISABLED: "This account is disabled and cannot be assigned.",
      USER_NOT_FOUND: "The user was not found or is not available to you.",
      SHARED_ACCOUNT: "This account is also used by another store; LUD support changes its details.",
      SETUP_RESEND_COOLDOWN: "An invitation was just sent. Wait a minute and try again.",
      ALREADY_SET_UP: "This user has already set the password.",
      CONCURRENT_CHANGE: "The account was changed at the same time. Try again.",
      NETWORK: "Could not reach the server.",
    },
    errorFallback: "The operation failed.",
  },
};

export const LOGIN_DOMAIN = "lud.net";
export const USERNAME_PATTERN = /^[a-z0-9](?:[a-z0-9._-]{1,38})[a-z0-9]$/;
